module.exports = __webpack_public_path__ + "static/media/logo.5261c31b.PNG";